// Полоса «Все сообщения остановлены» над содержимым листа (033: T012; FR-008, FR-009, SC-005;
// ASG-NTF-11). Видна на каждом экране тем, кто может остановить и возобновить сообщения
// (mail.stop: администратор клиента и контролёр); у остальных полосы и запроса нет. Состояние —
// delivery.safety.get фоновым опросом раз в 60 с, как колокольчик: сеанс не продлевает. В полосе —
// когда и кто остановил (роль без ФИО) и «Возобновить»: окно подтверждения с числом писем
// в очереди. «Отмена» возвращает фокус на «Возобновить»; после возобновления полосы нет — фокус
// встаёт на содержимое страницы. До 640 px полоса — в одну колонку: текст, под ним кнопка.
import { Button, Icon } from '@kp/ui';
import { OctagonPause } from '@kp/ui/icons';
import { useRef, useState } from 'react';
import type { RefObject } from 'react';
import { SafetyDialog, stoppedWhen, useMailSafety } from '../features/settings/mailing/safety.tsx';
import { can } from './permissions.ts';
import { useMe, useTimeZone } from './session.ts';

export const STOPPED_TEXT = 'Все сообщения остановлены';

export function StoppedBanner() {
  const me = useMe();
  return can(me.permissions, ['mail.stop']) ? <Strip /> : null;
}

function Strip() {
  const timeZone = useTimeZone();
  const safety = useMailSafety();
  const buttonRef = useRef<HTMLButtonElement>(null);
  /** Куда вернуть фокус после окна: на «Возобновить», а после возобновления — на страницу. */
  const returnRef: RefObject<HTMLElement | null> = useRef<HTMLElement>(null);
  const [open, setOpen] = useState(false);
  const data = safety.data;
  const stopped = data?.stopped ?? null;

  return (
    <div className="kp-stopped-slot" role="status">
      {stopped ? (
        <div className="kp-stopped">
          <p className="kp-stopped-text">
            <Icon icon={OctagonPause} />
            <span>
              <b>{STOPPED_TEXT}</b> <span className="t-num">{stoppedWhen(stopped, timeZone)}</span>
            </span>
          </p>
          <Button
            ref={buttonRef}
            size="sm"
            onClick={() => {
              returnRef.current = buttonRef.current;
              setOpen(true);
              // Число писем в очереди — свежее: окно называет его в последствиях.
              void safety.refetch();
            }}
          >
            Возобновить
          </Button>
        </div>
      ) : null}
      <SafetyDialog
        action="resume"
        open={open}
        onOpenChange={setOpen}
        queued={data?.queued ?? 0}
        onDone={() => {
          returnRef.current = document.getElementById('main');
        }}
        returnFocusRef={returnRef}
      />
    </div>
  );
}
